import ApplicationController from './application_controller'
import EditableText from 'components/EditableText'
import { createRoot } from 'react-dom/client'

class EditableBlockController extends ApplicationController {
  connect () {
    const content = Helpers.getEditorContent(this.element)

    const root = createRoot(this.element)
    root.render(
      <EditableText type='editor' text={content} />
    )
  }
}

export default EditableBlockController
